import * as fecha from 'fecha';
import HotelDatepicker from 'hotel-datepicker';

const body = document.body;

const booking = {
  url: null,
  maxPeople: 3,
  form: null,
  input_datepicker: null,
  input_datestart: null,
  input_dateend: null,
  input_counters: null,
  datepicker: null,
  modal: null,
  close: null,
};

function getDates(datesString) {
  // bookingdates: "2025-04-21 - 2025-04-23"
  const dates = datesString.split(' - ').map((date) => date.trim());

  if (dates.length !== 2) {
    throw new Error("Formato de fecha incorrecto. Usa 'YYYY-MM-DD - YYYY-MM-DD'");
  }

  return {
    arrive: dates[0],
    depart: dates[1],
  };
}

function getRooms(adults, childs) {
  const totalPeople = parseInt(adults, 10) + parseInt(childs, 10);
  return Math.ceil(totalPeople / booking.maxPeople); // 1 habitación cada 3 personas
}

function setBookingUrl(formData) {
  const url = new URL(booking.url);
  const { arrive, depart } = getDates(formData.bookingdates);
  const numberRooms = getRooms(formData.bookingAdults, formData.bookingChilds);

  const addParams = {
    arrive,
    depart,
    adult: formData.bookingAdults,
    child: formData.bookingChilds,
    rooms: numberRooms,
  };

  const newParams = new URLSearchParams([
    ...Array.from(url.searchParams.entries()),
    ...Object.entries(addParams),
  ]).toString();

  return new URL(`${url.origin}${url.pathname}?${newParams}`);
}

function datePicker() {
  booking.input_datestart.value = fecha.format(this.start, 'DD MMM YYYY');
  booking.input_dateend.value = fecha.format(this.end, 'DD MMM YYYY');
}

function counterUpdate(counterArgs) {
  const currentValue = parseInt(counterArgs.inputField.value, 10);
  counterArgs.decreaseBtn.disabled = currentValue <= counterArgs.min;
  counterArgs.increaseBtn.disabled = currentValue >= counterArgs.max;
}

function counterIncrease(counterArgs) {
  const currentValue = parseInt(counterArgs.inputField.value, 10);

  if (currentValue < counterArgs.max) {
    counterArgs.inputField.value = currentValue + 1;
  }

  counterUpdate(counterArgs);
}

function counterDecrease(counterArgs) {
  const currentValue = parseInt(counterArgs.inputField.value, 10);

  if (currentValue > counterArgs.min) {
    counterArgs.inputField.value = currentValue - 1;
  }

  counterUpdate(counterArgs);
}

function counterChange(counterArgs) {
  const currentValue = parseInt(counterArgs.inputField.value, 10);

  if (Number.isNaN(currentValue) || currentValue < counterArgs.min) {
    counterArgs.inputField.value = counterArgs.min;
  } else if (currentValue > counterArgs.max) {
    counterArgs.inputField.value = counterArgs.max;
  }

  counterUpdate(counterArgs);
}

function counter(counterDom) {
  const decreaseBtn = counterDom.querySelector('.js-counter__decrease');
  const increaseBtn = counterDom.querySelector('.js-counter__increase');
  const inputField = counterDom.querySelector('.js-counter__value');
  const counterArgs = {
    decreaseBtn,
    increaseBtn,
    inputField,
    min: parseInt(inputField.min, 10),
    max: parseInt(inputField.max, 10),
  };

  decreaseBtn.addEventListener('click', () => counterDecrease(counterArgs));
  increaseBtn.addEventListener('click', () => counterIncrease(counterArgs));
  inputField.addEventListener('input', () => counterChange(counterArgs));

  counterUpdate(counterArgs);
}

function submitBooking(event) {
  event.preventDefault();

  const formData = Object.fromEntries(new FormData(event.target).entries());
  const url = setBookingUrl(formData);

  window.open(url.href, '_blank');
}

function closeModal() {
  body.classList.remove('hidden');
  booking.url = null;
  booking.maxPeople = 3;
  booking.modal.classList.remove('is-active');
}

function openModal() {
  booking.url = this.dataset.url;
  booking.maxPeople = this.dataset.people || booking.maxPeople;

  booking.modal.addEventListener('transitionend', () => {
    body.classList.add('hidden');
  }, { once: true });

  booking.modal.classList.add('is-active');
}

export default function setBooking() {
  const buttons = document.querySelectorAll('.js-booking');

  if (!buttons.length) return;

  booking.form = document.querySelector('.js-modal-booking__form');
  booking.input_datepicker = document.querySelector('.js-modal-booking__datepicker');
  booking.input_datestart = document.querySelector('.js-modal-booking__start');
  booking.input_dateend = document.querySelector('.js-modal-booking__end');
  booking.input_counters = document.querySelectorAll('.js-modal-booking__counter');
  booking.datepicker = new HotelDatepicker(booking.input_datepicker, {
    clearButton: true,
    format: 'YYYY-MM-DD',
    moveBothMonths: true,
    topbarPosition: 'bottom',
    startOfWeek: 'monday',
    onSelectRange: datePicker,
  });

  booking.modal = document.querySelector('.js-modal-booking');
  booking.close = document.querySelector('.js-modal-booking__close');
  booking.input_counters.forEach(counter);

  buttons.forEach((button) => {
    button.addEventListener('click', openModal);
  });

  booking.form.addEventListener('submit', submitBooking);
  booking.close.addEventListener('click', closeModal);
}
